export default __webpack_public_path__ + "f7bdaf3809d75700f8f805169ffdaaf6.svg";